import { registerLocaleData } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import en from '@angular/common/locales/en';
import { NgModule } from '@angular/core';
import { BrowserModule, Meta } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, TitleStrategy } from '@angular/router';
import { AppTitleStrategy } from './app-title.strategy';
import { SharedModule } from '@app/shared.module';
import { SharedPagesModule } from '@app/shared/shared.pages.module';
import { en_US, NZ_I18N } from 'ng-zorro-antd/i18n';
import { CustomFormsModule } from 'ng2-validation';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ToastrModule } from 'ngx-toastr';
import 'rxjs/add/observable/forkJoin';
import 'rxjs/add/operator/take';
import 'rxjs/add/operator/takeLast';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';
import pkg from '../../package.json';
import { AppComponent } from './app.component';
import { ROUTES } from './app.routes';
import { APP_PROVIDERS } from './shared/services/main';
import { AppHttpInterceptor } from './shared/interceptors/http.interceptor';
import { VersionPopupWrapperComponent } from './shared/components/version-popup-wrapper/version-popup-wrapper.component';

// Add the following import statement
registerLocaleData(en);

@NgModule({
	declarations: [AppComponent, VersionPopupWrapperComponent],
	imports: [
		ToastrModule.forRoot(),
		TooltipModule.forRoot(),
		CustomFormsModule,
		BrowserAnimationsModule,
		BrowserModule,
		HttpClientModule,
		SharedModule,
		SharedPagesModule,
		RouterModule.forRoot(ROUTES),
	],
	providers: [
		...APP_PROVIDERS,
		{ provide: NZ_I18N, useValue: en_US },
		{ provide: HTTP_INTERCEPTORS, useClass: AppHttpInterceptor, multi: true },
		{ provide: TitleStrategy, useClass: AppTitleStrategy },
	],
	bootstrap: [AppComponent],
})
export class AppModule {
	constructor(private meta: Meta) {
		this.meta.addTag({ name: 'version', content: pkg.version });
	}
}
